import {AbstractApiRequestInterceptor} from 'core/abstract/AbstractApiRequestInterceptor';
import {getRequestId, REQUEST_ID_HEADER} from 'core/modules/request-id';
import {TRequestParameters} from 'core/types';

/**
 * интерцептор для добавления X-Request-ID во все исходящие запросы
 */
export class RequestIdRequestInterceptor extends AbstractApiRequestInterceptor {
    public intercept(request: TRequestParameters<RequestInit, Body>): TRequestParameters<RequestInit, Body> {
        const {body, options, url} = request;
        const requestId = getRequestId();

        if (!requestId) {
            return request;
        }

        return {
            body,
            options: {
                ...options,
                headers: {
                    ...(options?.headers ?? {}),
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    [REQUEST_ID_HEADER]: requestId,
                },
            },
            url,
        };
    }
}
